/**
 * Created by karora on 11/10/19.
 */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { VersionCount } from '../types/version-count';

@Component({
  selector: 'dash-versions',
  template: `<div class="active-versions">
  <div *ngFor="let ver of versionCounts" [className]="this.versionClass(ver)" (click)="gotoVersion(ver.swversion)">
    <span class="version-group">{{ver.swversion | version}}</span>
    <span class="group-count">{{ver.count}}</span>
  </div>
</div>
`,
  styles: [
    `.active-versions { display: block; }`,
    `.excellent { background-color: #00ff00; }`,
    `.great { background-color: #00e030; }`,
    `.good { background-color: #00b060; }`,
    `.ok { background-color: #00a090; }`,
    `.poor { background-color: orange; }`,
    `.bad { background-color: red; }`,
    `.active-versions div {
      display: inline-block;
      width: 5.2em;
      margin: 0 0.2em 0.2em 0.2em;
      padding: 0.05em 0.4em;
    }`,
    `active-versions div:hover { color: white; background-color: #607D8B; }`,
    `.version-group {
      display: inline-block;
      width: 2.7em;
      line-height: 3em;
      vertical-align: middle;
    }`,
    `.group-count {
      display: inline-block;
      width: 2.3em;
      line-height: 3em;
      vertical-align: middle;
      text-align: right;
    }`
  ],
})

export class DashVersionComponent implements OnInit {
  versionCounts: VersionCount[] = [];
  errorMessage: string;

  constructor(
    private hubService: HubService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.hubService.getVersionCounts().subscribe(
      (      versionCounts: VersionCount[]) => this.versionCounts = versionCounts,
      (      error: any) => this.errorMessage = <any>error,
    );
  }

  gotoVersion(version: string): void {
    console.log('Navigating to version ' + version);
    this.router.navigate(['/hubs/version/', version]).then(
      (fulfilled: boolean) => console.log('Gone to version: ' + version),
      reason => {
        console.log('Failed to go to version ' + version);
        console.log(reason);
      },
    );
  }

  versionClass(v: VersionCount): string {
    if (v && v.swversion) {
      switch (v.swversion) {
        case '1.1.4':
          return 'excellent';
        case '1.1.3':
          return 'great';
        case '1.1.0':
          return 'ok';
        case '1.0.10':
          return 'ok';
        case '1.0.8':
          return 'ok';
        case '1.0.5':
          return 'ok';
        case '1.0.0':
          return 'poor';
        case '0.7.2':
          return 'poor';
        case '0.9.18':
          return 'poor';
      }
      if (v.swversion > '1.1.0') {
        return 'good';
      }
    }

    return 'bad';
  }

}
